// extracted by mini-css-extract-plugin
module.exports = {"editor":"styles_editor__3xNt0"};